import { Injectable } from "@angular/core";
import { Blank, FeeType, Providers, RevenueTypeResponse } from "../models/information.model";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { CookieService } from "ngx-cookie-service";
import { environment } from "../../../environments/environment";
import { ApiMethodService } from "../../tools/services/api/method-api/apiMethod.service";
import { ParkingVehicleTypeResponse } from "../models/vehicle.model";
import { CityParkingInvoiceCustomerIdResponse } from "../models/invoice.model";
import { CityParkingCustomerInfoResponse } from "../models/customer.model";
import { CityParkingAddressSelectResponse } from "../models/register-parking";
import { optionResponse } from "../models/form.model";


@Injectable({
  providedIn: 'root',
})
export class ApiFormService {
  private baseUrl = `${environment.apiPrivateUrl}`;
  token = '';
  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private apiMethodService: ApiMethodService
  ) {
    this.token = this.cookieService.get('token');
  }

  // -------------------------  รายชื่อลูกค้า  -------------------------
  getCityParkingCustomerList(siteId?: number | null): Observable<CityParkingCustomerInfoResponse[]> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<CityParkingCustomerInfoResponse[]>(
      '/backoffice/GetCityPakringCustomersAll',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'GetCityPakringCustomersAll',
        token: token,
        headerOnly: false,
        ...(siteId ? { params: { siteId } } : {}),
      },
    );
  }
  // -------------------------  ที่อยู่ลูกค้า  -------------------------
  getCityAddressForSelectByCustomerId(
    customerId: number,
  ): Observable<CityParkingAddressSelectResponse[]> {
    const token = this.cookieService.get('token');
    const params = {
      customerId: customerId,
    };

    return this.apiMethodService.request<CityParkingAddressSelectResponse[]>(
      '/backoffice/GetCityAddressForSelectByCustomerId',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'GetCityAddressForSelectByCustomerId',
        token: token,
        params: params,
        headerOnly: false,
      },
    );
  }
  // -------------------------  ประเภทบัตร  -------------------------
  getParkingCardType(): Observable<optionResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<Array<{ id: number; name: string }>>(
      '/backoffice/GetCardType',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'GetCardType',
        token: token,
        headerOnly: false,
      },
    ).pipe(
      map(items => ({
        data: (items ?? []).map(item => ({
          id: item.id ?? (item as any).Id ?? 0,
          name: item.name ?? (item as any).Name ?? '',
        })),
        more: false,
      }))
    );
  }
  // ----------------------------- ลูกค้า -----------------------------
  getServiceProvider(): Observable<optionResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<optionResponse>(
      '/backoffice/GetCustomer',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'GetCustomer',
        token: token,
        headerOnly: false,
      },
    );
  }

  //  -----------------------  ประเภทชำระเงินเงิน  -------------------------
  getFeeType(): Observable<FeeType[]> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const url = this.baseUrl + '/backoffice/GetFeeType';
    return this.http.get<FeeType[]>(url, { headers });
  }

  // ประเภทธนาคาร
  getBank(site_id: number): Observable<Blank[]> {
    console.log("Get Bank Site ID: ", site_id)
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const url = this.baseUrl + `/backoffice/GetBankAccount?site_id=${site_id}`;
    console.log("Get Bank URL: ", url)
    return this.http.get<Blank[]>(url, { headers });
  }

  // ------------------------- สถานที่ -----------------------------------
  getLocationProvider(): Observable<optionResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<optionResponse>(
      '/backoffice/GetLocationProvider',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'GetLocationProvider',
        token: token,
        headerOnly: false,
      },
    );
  }
  getProviders(): Observable<Providers[]> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });
    const url = this.baseUrl + '/backoffice/GetProviders';
    return this.http.get<Providers[]>(url, { headers });
  }

  // -------------------------  ประเภทรถ  -------------------------
  getParkingVehicleType(): Observable<ParkingVehicleTypeResponse[]> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ParkingVehicleTypeResponse[]>(
      '/backoffice/GetParkingVehicleType',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'GetParkingVehicleType',
        token: token,
        headerOnly: false
      }
    );
  }
  // -------------------------  ใบแจ้งหนี้  -------------------------
  getCityInvoiceByCustomerId(customer_id: number): Observable<CityParkingInvoiceCustomerIdResponse[]> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<CityParkingInvoiceCustomerIdResponse[]>(
      '/backoffice/GetCityInvoiceByCustomerId',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'GetCityInvoiceByCustomerId',
        token: token,
        headerOnly: false
      }
    );
  }

  // -------------------------  รายได้  -------------------------
  getParkingFeeInfo(): Observable<RevenueTypeResponse[]> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<RevenueTypeResponse[]>(
      '/backoffice/GetParkingFeeInfo',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'GetParkingFeeInfo',
        token: token,
        headerOnly: false
      }
    );
  }
}
